<template>
  <div class="form_root">
    <div class="text-left">
      <h3>
        <router-link to="/mensagens">Mensagem</router-link> » {{crud_action}}
        <button v-if="!loading" @click.prevent="save()" class="btn btn-success pull-right">Salvar</button>
        <button v-else class="btn btn-muted pull-right">Aguarde...</button>
      </h3>
      <hr>
    </div>
    <!-- MENSAGEM -->
    <div class="form-group col-sm-8">
      <label class="control-label">Mensagem</label>
      <wysiwyg ref="msg" hideFile="true" hideAlign="true" hideInserts="true" ></wysiwyg>
    </div>
    <div class="col-sm-3">
      <label for="">Data Início</label>
    </div>
    <div class="col-sm-3">
      <div class="input-group">
        <input ref="dtiniciodisplay" value="" type="text" class="form-control" disabled>
        <Calendario v-if="showCalendarDtInicio" @pickDate="setDate" class="calendario"></Calendario>
        <div class="input-group-btn">
          <button class="btn btn-primary" @click="showCalendarDtInicio=true"><i class="glyphicon glyphicon-calendar"></i></button>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <br>
      <label for="">Data Término</label>
    </div>
    <div class="col-sm-3">
      <div class="input-group">
        <input ref="dtfimdisplay" value="" type="text" class="form-control" disabled>
        <Calendario v-if="showCalendarDtFim" @pickDate="setDate" class="calendario"></Calendario>
        <div class="input-group-btn">
          <button class="btn btn-primary" @click="showCalendarDtFim=true"><i class="glyphicon glyphicon-calendar"></i></button>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <br>
      <label>Ref. Atualização Cód.</label>
    </div>
    <div class="col-sm-3">
      <div class="input-group">
        <input type="text" v-model="form.atucodig" class="form-control" placeholder="Um cód. por mensagem">
      </div>
    </div>
    <div class="col-sm-3 text-center">
      <br>
      <button @click.prevent="remove()" class="btn btn-danger">Excluir Mensagem</button>
    </div>
    <br><br><br>
  </div>
</template>

<script>
import wysiwyg from './Wysiwyg'
import Calendario from './Calendar'
import swal from 'sweetalert'
export default {
  name: '',
  components: {
    wysiwyg, Calendario
  },
  data () {
    return {
      loading: false,
      showCalendarDtInicio: false,
      showCalendarDtFim: false,
      crud_action: '',
      form: {
        cod: 0,
        msg: '',
        dt_inicio: undefined,
        dt_fim: undefined,
        atucodig: ' '
      }
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getmsg.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.fetchData(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    fetchData (o) {
      this.form = o
      this.form.atucodig = (o.atucodig === -1) ? '' : o.atucodig
      this.form.dt_inicio = o.dt_inicio.replace(/-/g, '').substring(0, 8)
      this.form.dt_fim = o.dt_fim.replace(/-/g, '').substring(0, 8)
      this.$refs.dtiniciodisplay.value = this.formatData(this.form.dt_inicio)
      this.$refs.dtfimdisplay.value = this.formatData(this.form.dt_fim)
      this.$refs.msg.setContent(o.msg)
    },
    save () {
      if (this.form.dt_inicio === undefined || this.form.dt_fim === undefined) {
        swal('Ops...', 'Os campos referentes a DATA de inicio e término são obrigatórios', 'error')
      } else {
        this.form.msg = this.$refs.msg.getContent()
        const url = './api/php/addmsg.php'
        this.$http.post(url, JSON.stringify(this.form)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              swal('Mensagem Cadastrada', '', 'success')
            }
            this.closeForm()
          },
          function (error) {
            console.log(error)
          }
        )
      }
    },
    remove () {
      const url = './api/php/removemsg.php'
      this.$http.post(url, JSON.stringify(this.form)).then(
        function (response) {
          console.log(response.body)
          if (response.body.status) {
            swal('Ok', response.body.msg, 'success')
            this.closeForm()
          } else {
            swal('Ops...', response.body.erro, 'error')
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    setDate (date) {
      console.log('DtPicked: ' + date)
      if (this.showCalendarDtInicio === true) {
        this.showCalendarDtInicio = false
        this.form.dt_inicio = date
        this.$refs.dtiniciodisplay.value = this.formatData(date)
      } else {
        this.showCalendarDtFim = false
        this.form.dt_fim = date
        this.$refs.dtfimdisplay.value = this.formatData(date)
      }
    },
    formatData (date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4)
      }
    },
    closeForm () {
      this.$router.push({path: '/mensagens'})
    }
  },
  created: function () {
    const crud = this.$route.params.crud
    const cod = this.$route.params.id
    if (crud === 'c') {
      // Criar nova MSg
      console.log('Criando nova msg')
      this.crud_action = 'Novo'
    } else if (crud === 'u') {
      // Altera uma Msg
      console.log('Alterando um email')
      this.crud_action = 'Alterando (#' + cod + ')'
      this.load({'cod': cod})
    } else {
      console.log('CRUD INVÁLIDO EM FORM EMAIL')
    }
  }
}
</script>

<style scoped>
  .loading {
    background: url("../assets/loading.gif") center no-repeat;
    background-size: cover;
    display: block;
    width: 30vw;
    height: 30vh;
    margin: 25vh 35vw;
  }
  .form_root {
      text-align: left;
      margin: auto;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
    .calendario {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 100;
    }
</style>



// WEBPACK FOOTER //
// src/components/MensagemForm.vue